@if (allPharmacys.length) {
  <div class="mat-typography mat-body mat-app-background pharmacy-detail-container" [formGroup]="pharmForm">
    <h2 class="drug-cost-header">Pharmacies</h2>
    <mat-radio-group formControlName="pharmControl">
      <div class='drug-cost-row'>
        @for (pharm of allPharmacys; track pharm) {
          <div class='col-md-4 pharmacy-detail'>
            <mat-radio-button [value]="pharm.pharmacyId"></mat-radio-button>
            <div class='pharmacy-info' (click)="selectPharmacy(pharm)">
              <h3 class='pharm-name-header bottom-space-0'>{{pharm.name}}</h3>
              <div>{{pharm.address1}}</div>
              <div>{{pharm.address2}}</div>
              <div>{{pharm.city}}, {{pharm.state}}</div>
              @if (pharm.inNetwork === true) {
                <div><span class="material-symbols-outlined in-network">check_circle_outline </span>In Network</div>
              }
              @if (pharm.inNetwork === false) {
                <div><span class="material-symbols-outlined out-of-network">highlight_off </span>Out of Network</div>
              }
              @if (pharm.isPreferred) {
                <div><span class="material-symbols-outlined in-network">check_circle_outline </span>Preferred Pharmacy</div>
              }
            </div>
          </div>
        }
      </div>
    </mat-radio-group>
  </div>
}